/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/back-arrow-otg': {
    width: 15,
    height: 11,
    viewBox: '0 0 15 11',
    data: '<g clip-path="url(#clip0_719_7038)"><path pid="0" d="M5.621 11l.96-.917-3.975-3.928h12.062v-1.31H2.606L6.58.917 5.62 0 .001 5.5l5.62 5.5z" _fill="#37A48B"/></g><defs><clipPath id="clip0_719_7038"><path pid="1" _fill="#fff" transform="rotate(-180 7.334 5.5)" d="M0 0h14.667v11H0z"/></clipPath></defs>'
  }
})
